// Native device-shell detection — true ONLY inside the Symbols shell (the
// Tauri WKWebView wrapping my.symbols.app), false in every real browser
// including iOS Safari itself. Two independent signals, either suffices:
// 1. UA token — the shell appends `SymbolsShell` to the WebView user agent
//    (the shell's tauri.conf.json owns that config; this helper is written
//    against that contract).
// 2. Tauri runtime marker — `window.__TAURI_INTERNALS__` is injected by the
//    Tauri webview bootstrap, so detection holds even on a device build
//    where the UA config hasn't landed yet.
// Gates auth affordances that cannot work inside an embedded webview
// (Google OAuth — see shared/components/LoginWindow.js). Available anywhere
// via el.call('isNativeShell').
export const isNativeShell = () => {
  if (typeof window === 'undefined') return false
  if (typeof navigator !== 'undefined' && navigator.userAgent?.includes('SymbolsShell')) return true
  return !!window.__TAURI_INTERNALS__
}

// Deep-link scheme THIS build's native shell registers to receive the OAuth
// return trip (workspace/native/ipad/README.md "Build variants" —
// tauri.conf.json registers `symbols`, the canary overlay
// tauri.canary.conf.json registers `symbols-canary`, the staging overlay
// tauri.staging.conf.json registers `symbols-staging`; Rust's own
// `AUTH_SCHEMES` in src-tauri/src/lib.rs accepts all three). The builds
// install side by side on one device, so a single hardcoded scheme is
// ambiguous the moment two exist — derive it from the SAME UA token
// isNativeShell() already reads (`SymbolsShell/0.1.0 SymbolsCanary` for the
// canary build, see the README's UA-token row) rather than adding a second,
// independent signal that could drift from the shell's actual registration.
// Used by google-auth.js to bind the native OAuth `state` to the calling
// build (el.call('nativeShellScheme')).
//
// EVERY variant needs a row in BOTH structures below and in the server's own
// allowlist (AuthOAuthController NATIVE_AUTH_SCHEMES) — a variant missing
// from the server list silently falls back to `symbols`, so its Google
// sign-in returns into the PROD app instead of itself. That is exactly what
// happened when the staging variant shipped ahead of these entries.
export const NATIVE_AUTH_SCHEMES = ['symbols', 'symbols-canary', 'symbols-staging']

// UA token → scheme. Tokens are checked most-specific-first and are mutually
// exclusive by construction (each variant's conf.json sets exactly one).
const SCHEME_BY_UA_TOKEN = [
  ['SymbolsCanary', 'symbols-canary'],
  ['SymbolsStaging', 'symbols-staging']
]

export const nativeShellScheme = () => {
  const ua = typeof navigator !== 'undefined' ? navigator.userAgent : ''
  const hit = SCHEME_BY_UA_TOKEN.find((pair) => ua?.includes(pair[0]))
  return hit ? hit[1] : 'symbols'
}
